<template>
  <div>
    <table-component-buefy
      v-if="showTable"
      :content="content"
      :headings="headings"
      :filters="customFilters"
      :item_keys="item_keys"
      :display_spec="display_spec"
      :total_items="mixin.total_items"
      :hide_table_search="hide_table_search"
      :pagination_callback="mixin.loadItems"
      :hidden_columns="hidden_columns"
      :focus_on_load="focus_on_load"
      :class="table_classes">
      <slot></slot>
    </table-component-buefy>
    <message-component v-else-if="hasMessage" :level="'info'">
      <slot name="message"></slot>
    </message-component>
  </div>
</template>
<script>
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import { loadItemsMixin } from '@/mixins/mixins'
  import TableFilter from '@/classes/case/TableFilter'

  export default {
    name: 'table-load-item-component',
    mixins: [loadItemsMixin],
    data () {
      return {
        isTableEmpty: false,
        mixin: {
          actionMethod: this.action_method,
          computedActionParams: this.computed_action_params
        },
        dateFilter: {
          date_created: {
            type: TableFilter.FILTER_TYPE_DATE_RANGE,
            limit_start: 'created_gte',
            limit_end: 'created_lte'
          }
        }
      }
    },
    components: {
      TableComponentBuefy,
      MessageComponent
    },
    computed: {
      showTable () {
        return this.mixin.loaded && !this.isTableEmpty
      },
      hasMessage () {
        return !!this.$slots['message']
      },
      customFilters () {
        if (this.hide_table_filters) {
          return {}
        }
        return Object.assign(this.mixin.filters, this.dateFilter)
      }
    },
    props: {
      focus_on_load: {
        type: Boolean,
        default: true
      },
      action_method: {
        type: Function,
        required: true
      },
      computed_action_params: {
        type: Function,
        default: () => {}
      },
      content: {
        type: Array,
        required: true
      },
      headings: {
        type: Array,
        required: true
      },
      item_keys: {
        type: Array,
        required: true
      },
      hidden_columns: {
        type: Array,
        required: true
      },
      display_spec: {
        type: Array,
        required: true
      },
      table_classes: {
        type: String,
        default: ''
      },
      hide_table_search: {
        type: Boolean,
        default: false
      },
      hide_table_filters: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.mixin.init.then(() => {
        this.isTableEmpty = !this.content.length
      })
    }
  }
</script>
